;(() => {
  let count = localStorage.getItem('windowCount')
  count = count ? JSON.parse(count) : 0
  let refresh = sessionStorage.getItem('refresh')
  let forceNotClear = localStorage.getItem('forceNotClear')
  if (count <= 0 && !refresh && !forceNotClear) localStorage.clear()
})()

// Polyfills
import 'babel-polyfill'
import './lib/polyfills'
import 'whatwg-fetch'

// Courtesty of webpack loader, we can load our global styles here
import './assets/styles/globals.scss'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'

import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

import { AuthorizationPlugin } from '@/lib/plugins/authorization'
Vue.use(AuthorizationPlugin)

Vue.config.productionTip = false

// Commonly used components
import FormError from '@/components/FormError'
import FormErrorAlert from '@/components/FormErrorAlert'
import ICEAlert from '@/components/ICEAlert'
import { globalError } from './lib/utils'
Vue.component('FormError', FormError)
Vue.component('FormErrorAlert', FormErrorAlert)
Vue.component('ICEAlert', ICEAlert)

Vue.mixin({
  computed: {
    printable() {
      return this.$route.query.print && JSON.parse(this.$route.query.print)
    },
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.config.keyCodes.home = 36
Vue.config.keyCodes.pageup = 33
Vue.config.keyCodes.pagedown = 34

if (window.localStorage.getItem('idToken'))
  store.dispatch('account/retrieveInfo')

store.dispatch('loadAnnouncement')

// Track window counts to kill the session when it is finished
if (!localStorage.getItem('windowCount')) {
  localStorage.setItem('windowCount', 1)
} else {
  let count = JSON.parse(localStorage.getItem('windowCount'))
  localStorage.setItem('windowCount', count + 1)
}

window.addEventListener('unload', () => {
  let count = JSON.parse(localStorage.getItem('windowCount') || 1)
  localStorage.setItem('windowCount', count - 1)
})

window.sessionStorage.setItem('refresh', true)

// Look for an error that is set to survive refresh.
;(() => {
  let refreshError = window.localStorage.getItem('refreshError')
  if (!refreshError) return
  refreshError = JSON.parse(refreshError)
  globalError(null, refreshError)
  window.localStorage.removeItem('refreshError')
})()

